import React, { useState } from 'react';
import { Col, Tab, Tabs } from 'react-bootstrap';
import MessagesList from './MessagesList';
import MessageDetailComponent from './component/MessageDetailComponent';
import CustomPaginationItemsDisplay from '../../common/pagination/CustomPaginationItemsDisplay';
import CustomPagination from '../../common/pagination';
import MessageListSkeleton from './skeleton/MessageListSkeleton';
import MessageDetailSelecton from './skeleton/MessageDetailSelecton';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';

function MessagingParent({
  pageSize,
  currentPage,
  displayPaginationMininumCount,
  pageSizeHandler,
  recordsPerPage,
  paginationHandler,
  selectedTab,
  setSelectedTab,
  setSelectedIndex,
  selectedIndex,
  setSelectedIndexForSent,
  selectedIndexForSent,
  listLoading,
  messageDetailData,
  getSanitizedContent,
  downloadFileHandler,
  downloadAllFileHandler,
  setIsComposed,
  getSendReceiveMessageDetail,
  messageDetailLoading,
  messageDetailApiServerError,
  messageDetailApiDataNotFoundError,
  sendNewMessageFormRef,
  sendReplyMessageFormRef,
  mainSelectedTab,
  ...props
}) {
  const [accessibilityCurrentPage, setAccessibilityCurrentPage] = useState(0);
  const ListUser = (index, item) => {
    if (selectedTab === 'inbox') {
      setSelectedIndex(index);
    } else {
      setSelectedIndexForSent(index);
    }
    getSendReceiveMessageDetail(
      item?.callid || item?.EventTitle,
      Boolean(item?.callid),
      item?.oid,
      item?.isread,
    );
    props?.setIsComposing(false);
    props?.setReplyEnabled(false);
  };

  const tabClickHandler = (e) => {
    setSelectedTab(e);
    setSelectedIndex(0);
    setSelectedIndexForSent(0);
  };

  return (
    <div>
      <div className="d-flex justify-content-between mt-4 mb-4">
        {props?.totalRecords > displayPaginationMininumCount &&
        !(listLoading || props?.listLoading) ? (
          <>
            <div
              role="status"
              className="sr-only"
            >{`${props?.totalRecords} results found`}</div>
            <CustomPaginationItemsDisplay
              pageSize={pageSize}
              recordsPerPage={recordsPerPage}
              setPageSize={pageSizeHandler}
              prefixMessage="Records per page"
              suffixMessage={`Showing ${
                currentPage * pageSize - pageSize + 1
              } - ${
                pageSize * currentPage < props?.totalRecords
                  ? pageSize * currentPage
                  : props?.totalRecords
              } of ${props?.totalRecords} results`}
            />
          </>
        ) : null}

        <div className="d-flex align-items-center">
          {props?.totalRecords > displayPaginationMininumCount &&
          !(listLoading || props?.listLoading) ? (
            <CustomPagination
              className="p-0 m-0"
              pageSize={pageSize}
              currentPage={currentPage}
              totalCount={props?.totalRecords}
              onPageChange={paginationHandler}
              accessibilityPagination={true}
              accessibilityCurrentPage={accessibilityCurrentPage}
              setAccessibilityCurrentPage={setAccessibilityCurrentPage}
            />
          ) : null}
        </div>
      </div>
      <div className="d-flex">
        <Col className="bg-white pr-0 pl-0 h-100 mr-5">
          {listLoading || props?.listLoading ? (
            <MessageListSkeleton />
          ) : (
            <Tabs
              activeKey={selectedTab}
              defaultActiveKey="inbox"
              id="uncontrolled-tab-example"
              className=""
              onSelect={tabClickHandler}
            >
              {(selectedTab === 'inbox' || true) && (
                <Tab eventKey="inbox" title="Inbox">
                  <MessagesList
                    ListUser={ListUser}
                    selectedIndex={selectedIndex}
                    data={props?.data}
                  />
                </Tab>
              )}
              {(selectedTab === 'sent' || true) && (
                <Tab eventKey="sent" title="Sent">
                  <MessagesList
                    ListUser={ListUser}
                    selectedIndex={selectedIndexForSent}
                    data={props?.data}
                    getSanitizedContent={getSanitizedContent}
                  />
                </Tab>
              )}
            </Tabs>
          )}
        </Col>
        <Col lg={7} md={7} className="pr-0 pl-0">
          {listLoading || props?.listLoading || messageDetailLoading ? (
            <MessageDetailSelecton />
          ) : messageDetailApiServerError ? (
            <CustomClientError
              ErrorHeading={
                messageDetailApiDataNotFoundError
                  ? 'No result found!'
                  : 'Something went wrong with request!'
              }
              ErrorMessage={
                messageDetailApiDataNotFoundError
                  ? 'No result found with the selected filters, Please try again'
                  : 'Please try again.'
              }
            />
          ) : (
            <MessageDetailComponent
              isComposing={props?.isComposing}
              setIsComposing={props?.setIsComposing}
              replyEnabled={props?.replyEnabled}
              setReplyEnabled={props?.setReplyEnabled}
              selectedData={messageDetailData}
              getSanitizedContent={getSanitizedContent}
              onDownload={downloadFileHandler}
              onDownloadAll={downloadAllFileHandler}
              setIsComposed={setIsComposed}
              sendNewMessageFormRef={sendNewMessageFormRef}
              sendReplyMessageFormRef={sendReplyMessageFormRef}
              mainSelectedTab={mainSelectedTab}
            />
          )}
        </Col>
      </div>
      <div className="d-flex justify-content-between mt-4 pagination-container-2">
        {props?.totalRecords > displayPaginationMininumCount &&
        !(listLoading || props?.listLoading) ? (
          <CustomPaginationItemsDisplay
            pageSize={pageSize}
            setPageSize={pageSizeHandler}
            prefixMessage="Records per page"
          />
        ) : null}

        <div className="d-flex align-items-center">
          {props?.totalRecords > displayPaginationMininumCount &&
          !(listLoading || props?.listLoading) ? (
            <CustomPagination
              className="p-0 m-0"
              pageSize={pageSize}
              currentPage={currentPage}
              totalCount={props?.totalRecords}
              onPageChange={paginationHandler}
              accessibilityPagination={true}
              accessibilityCurrentPage={accessibilityCurrentPage}
              setAccessibilityCurrentPage={setAccessibilityCurrentPage}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default MessagingParent;
